import { getNativeInfo } from './core';
export { getNativeInfo };

var _a = getNativeInfo(),
    isApp = _a.isApp,
    env = _a.env,
    app = _a.app,
    appVersion = _a.appVersion,
    device = _a.device,
    osVersion = _a.osVersion;

export { isApp, env, app, appVersion, device, osVersion };